import React from 'react';
import {connect} from 'react-redux';
import {addItem} from '../redux.js';

class Product extends React.Component{
	constructor(props){
		super(props);
		this.state={
			count: 0
		};
		this.quantityButton=React.createRef();
		this.slidePict=this.slidePict.bind(this);
		this.selectPict=this.selectPict.bind(this);
		this.addItem=this.addItem.bind(this);
	}
	slidePict(n){
		if(this.state.count+n<0||this.state.count+n>this.props.product.img.length-1)return false;
		this.setState({count:this.state.count+n});
	}
	selectPict(n){
		this.setState({count:n});
	}
	addItem(){
		this.props.addItem({
			name:this.props.product.name,
			img:this.props.product.img[0],
			price:this.props.product.price,
			quantity:+this.quantityButton.current.value
		});
	}
	render(){
		return(
			<section className='product'>
				<div className='pictures'>
					<div className='pictures-main'>
						<img onClick={() =>this.slidePict(-1)}className='arrow left' src={require('../../img/arrow.png')}/>
						<img src={require(`../../img/${this.props.product.img[this.state.count]}`)}/>
						<img onClick={() =>this.slidePict(1)}className='arrow right' src={require('../../img/arrow.png')}/>
					</div>
					<div className='pictures-list'>
						{
							this.props.product.img.map((i,n) =>{
								return <img  key={n} onClick={() =>this.selectPict(n)} src={require(`../../img/${i}`)}/>
							})
						}
					</div>
				</div>
				<ul className='des'>
					<li className='anime'><span>назва</span><div className='line'></div>{this.props.product.name}</li>
					<li className='anime'><span>об'эм</span><div className='line'></div>{this.props.product.amount} m</li>
					<li className='anime'><span>дiаметр</span><div className='line'></div>{this.props.product.diametr} см</li>
					<li className='anime'><span>висота</span><div className='line'></div>{this.props.product.height} см</li>
					<li className='anime'><span>матерiал</span><div className='line'></div>{this.props.product.material}</li>
					<li className='anime'><span>цiна</span><div className='line'></div>{this.props.product.price} $</li>
				</ul>
				<form>
					<input ref={this.quantityButton} defaultValue='1' min='1' type='number'/>
					<input onClick={this.addItem} type='button' value='в кошик'/>
				</form>
			</section>
		)
	}
}

export default connect(
	state =>({
		store: state
	}),
	dispatch =>({
		addItem:(item) =>{
			dispatch(addItem(item))
		}
	})
)(Product);